import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ScheduledJob, ScheduledJobCreate, ScheduledJobFilter } from '../data/scheduledJob';

export function createScheduledJobService(client: AxiosInstance) {
  return createCrudService<ScheduledJob, ScheduledJobCreate, ScheduledJobFilter>(
    client,
    '/platform/ScheduledJob',
    'id',
  );
}

export type ScheduledJobService = CrudService<ScheduledJob, ScheduledJobCreate, ScheduledJobFilter>;
